export enum Experiments {
  ORDER_ENTRY_PRICE_EDITING = 'order-entry-price-editing',
  ORDER_MANAGEMENT_DESKTOP_EXPERIMENT = 'order_management_desktop_experiment',
  PRICE_QUOTES_BUILDER = 'price-quotes-builder',
  SALES_PORTAL_ACCOUNTS_V1 = 'sales-portal-accounts-v1',
  SALES_PORTAL_INSIGHTS_V1 = 'sales-portal-insights-v1',
  SALES_PORTAL_NATIVE_MOBILE = 'sales-portal-native-mobile',
  SALES_PORTAL_ORDER_ENTRY_MOBILE_V1 = 'sales-portal-order-entry-mobile-v1',
}
